import { ModalFactory } from '@rendora/common/features/modals/factory';
import { h } from 'vue';
import ProtocolContent from './ProtocolContent.vue';

const symbolProtocolConfirm = Symbol('protocol-confirm');

/**
 * 协议确认弹窗 composable
 * 提供统一的协议确认弹窗管理功能
 */
export function useProtocolConfirm() {
  /**
   * 关闭协议确认弹窗
   */
  const close = () => {
    const modal = ModalFactory.getInstance(symbolProtocolConfirm);
    modal?.close();
  };

  /**
   * 显示协议确认弹窗
   * @param onConfirm 确认回调函数
   * @returns ModalInstance
   */
  const show = (onConfirm: () => void) => {
    const handleConfirm = () => {
      onConfirm();
      const modal = ModalFactory.getInstance(symbolProtocolConfirm);
      modal?.close();
    };

    // 检查是否已存在弹窗实例
    if (ModalFactory.hasModal(symbolProtocolConfirm)) {
      const modal = ModalFactory.getInstance(symbolProtocolConfirm);
      modal?.update({
        content: h(ProtocolContent, { onConfirm: handleConfirm, onCancel: close }),
      });
      return modal;
    }

    // 创建新的弹窗实例
    const modal = ModalFactory.create(
      {
        title: ' ',
        width: '500px',
        height: '198px',
        showHeader: true,
        showCloseButton: true,
        closeOnOverlayClick: false,
        closeOnEsc: true,
        maskClosable: false,
        centered: true,
        content: h(ProtocolContent, { onConfirm: handleConfirm, onCancel: close }),
      },
      symbolProtocolConfirm,
    );

    return modal;
  };

  return {
    show,
    close,
  };
}
